<template>
  <div class="layout">
    <el-container class="scrollbar-y">
      <el-aside :width="!isCollapse ? '230px' : '64px'">
        <div class="logo bc-white display-flex ai-center jc-center cursor-pointer" style="border-bottom: 1px solid #DCDFE6">
          <span v-if="!isCollapse" class="logo-name fs-14 fw-bolder ml-10 animate__animated animate__bounceIn">
            安全生产信息化运营平台</span>
        </div>
        <el-scrollbar style="height: calc(100% - 53px)">
          <el-menu
            router
            :collapse-transition="false"
            :collapse="isCollapse"
            unique-opened
            :default-active="$route.fullPath">
            <template v-for="item in menu">
              <el-submenu v-if="item.children && item.children.length" :index="item.path" :key="item.path">
                <template slot="title">
                  <i class="fs-18 mr-4" :class="menuIconClass(item.meta.iconUrl)"></i>
                  <span>{{ item.meta.title }}</span>
                </template>
                <el-menu-item
                  v-for="_item in item.children"
                  :key="_item.path"
                  :index="_item.path">{{ _item.meta.title }}
                </el-menu-item>
              </el-submenu>
              <!-- 无子级的独立页面：直接可点击 -->
              <el-menu-item v-else :index="item.path" :key="item.path">
                <i class="fs-18 mr-4" :class="menuIconClass(item.meta.iconUrl)"></i>
                <span slot="title">{{ item.meta.title }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-container>
        <el-header height="104px" class="bc-white display-flex fd-column jc-center pl-0">
          <div class="display-flex ai-center jc-space-between flex-1 pl-20">
            <div class="display-flex ai-center">
              <i @click="isCollapse = !isCollapse" v-if="!isCollapse"
                 class="mr-12 el-icon-s-fold fs-22 cursor-pointer"></i>
              <i @click="isCollapse = !isCollapse" v-else class="mr-12 el-icon-s-unfold fs-22 cursor-pointer"></i>
              <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item v-for="(item, index) in breadcrumb" :key="index">
                  {{ item.title }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="display-flex ai-center">
              <el-dropdown>
                <div class="display-flex ai-center">
<!--                  <el-avatar :size="30" :src="avatar" fit="cover"></el-avatar>-->
                  <span class="cursor-pointer ml-14 fs-14">
                    {{ username }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="showEditPwd = true">
                    <span>修改密码</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="loginOut">
                    <span>退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="flex-1 display-flex ai-center jc-space-between pl-20">
            <div class="tag-views scrollbar-x">
              <div
                @click="$router.push(view.path)"
                :ref="`view-${view.path}`"
                class="view animate__animated"
                :class="view.path === $route.fullPath ? 'view-active' : ''"
                v-for="view in views"
                :key="view.path">
                <i v-if="view.path === '/home/index'" class="el-icon-s-home mr-8"></i>
                <span class="mr-8">{{ view.title }}</span>
                <i v-if="view.path !== '/home/index'" class="el-icon-error"
                   @click.stop="closeView(view)"></i>
              </div>
            </div>
            <div class="display-flex ai-center ml-10">
              <span @click="refreshView" class="refresh-btn">
                <i ref="refresh" class="el-icon-refresh color-primary mr-10 fs-16 refresh paused"></i>
                刷新当前页
              </span>
              <el-dropdown>
                <i class="el-icon-more padding-6 fs-18 cursor-pointer ml-4"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :disabled="$route.path === '/home/index'"
                    @click.native="closeView($route)"
                    icon="el-icon-close">
                    关闭当前页
                  </el-dropdown-item>
                  <el-dropdown-item
                    :disabled="views.length === 1"
                    @click.native="closeOtherView($route)"
                    icon="el-icon-circle-close">
                    关闭其他页
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <el-main class="scrollbar-y">
          <el-scrollbar>
<!--            <keep-alive :include="cachedViews">-->
<!--              <router-view class="animate__animated animate__fadeIn" :key="key"/>-->
<!--            </keep-alive>-->
            <router-view class="animate__animated animate__fadeIn" :key="key"/>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
    <change-password :show-dialog="showEditPwd" @hideDialog="showEditPwd = false" @submitDialog="showEditPwd = false"></change-password>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ChangePassword from '@/components/ChangePassword';

export default {
  name: 'Index',
  components: { ChangePassword },
  props: {},
  data () {
    return {
      isCollapse: false,
      showEditPwd: false
    }
  },
  filters: {},
  computed: {
    ...mapState({
      cachedViews: state => state.cachedViews,
      breadcrumb: state => state.breadcrumb,
      username: state => state.userInfo.name || '',
      avatar: state => state.userInfo.avatarTmpUrl || '',
      views: state => state.views,
      menu: state => state.menu
    }),
    key () {
      return this.$route.path
    }
  },
  watch: {
    $route (to) {
      this.SetCachedViews()
      this.setBreadcrumb(to)
      this.setViews(to)
      this.$nextTick(() => {
        if (this.$refs[`view-${to.fullPath}`]) {
          this.$refs[`view-${to.fullPath}`][0].scrollIntoView()
        }
      })
    }
  },
  methods: {
    menuIconClass (iconUrl) {
      return iconUrl && iconUrl.indexOf('el-icon-') !== 0 ? ['iconfont', iconUrl] : iconUrl
    },
    /**
     * 设置缓存页面
     */
    SetCachedViews () {
      // 不缓存的页面
      const exclude = ['test']
      if (exclude.includes(this.$route.name)) {
        return false
      }
      if (!this.cachedViews.includes(this.$route.name)) {
        this.$store.dispatch('SetCachedViews', this.cachedViews.concat(this.$route.name))
      }
    },
    /**
     * 设置标签页
     */
    setViews (to) {
      if (to.path.includes('/redirect/')) {
        return false
      }
      if (!this.views.filter(item => item.path === to.fullPath).length) {
        this.$store.commit('SET_VIEWS',
          this.views.concat({
            title: to.meta.title,
            name: to.name,
            path: to.fullPath
          })
        )
      }
    },
    /**
     * 设置面包屑
     */
    setBreadcrumb (to) {
      // 独立页面会被包一层 Layout 父路由（无 title），过滤无标题记录并按 path 去重避免面包屑重复
      const matched = to.matched
        .filter(item => item.meta && item.meta.title)
        .filter((item, index, arr) => index === 0 || item.path !== arr[index - 1].path)
      this.$store.commit('SET_BREADCRUMB', matched.map(item => {
        return {
          title: item.meta.title,
          name: item.name,
          path: item.fullPath || '/'
        }
      }))
    },
    /**
     * 退出登录
     */
    loginOut () {
      this.$confirm('你确认要退出登录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.location.href = '/auth_login'
        setTimeout(() => {
          this.$store.dispatch('SetCachedViews', this.cachedViews.filter(item => item === 'Home')).then(() => {
            this.$store.commit('SET_VIEWS', this.views.filter(item => item.path === '/home/index'))
            this.$store.commit('SET_MENU', [])
            this.$store.commit('SET_USER_INFO', {})
            this.$store.commit('SET_TOKEN', '')
            this.$cookies.remove('token')
          })
        }, 500)
      }).catch(() => {
      });
    },
    /**
     * 关闭当前页面
     * @param view {Object} 类似路由信息
     */
    closeView (view) {
      this.$refs[`view-${view.path}`][0].classList.add('animate__fadeOutUp')
      setTimeout(() => {
        const index = this.views.findIndex(item => item.path === view.path)
        this.$store.dispatch('SetCachedViews', this.cachedViews.filter(item => item !== view.name)).then(() => {
          this.$store.commit('SET_VIEWS', this.views.filter(item => item.path !== view.path))
          if (view.path === this.$route.fullPath) {
            this.$router.replace(`${this.views[index - 1].path}`)
          }
        })
      }, 500)
    },
    /**
     * 关闭其他页面
     * @param view {Object} 类似路由信息
     */
    closeOtherView (view) {
      this.$store.dispatch('SetCachedViews', this.cachedViews.filter(item => ['Home', view.name].includes(item))).then(() => {
        this.$store.commit('SET_VIEWS', this.views.filter(item => ['/home/index', view.path].includes(item.path)))
      })
    },
    /**
     * 刷新当前页面
     */
    refreshView () {
      this.$refs.refresh.classList.remove('paused')
      this.$refs.refresh.classList.add('active')
      // 删除掉缓存记录
      if (this.cachedViews.includes(this.$route.name)) {
        this.$store.dispatch('SetCachedViews', this.cachedViews.filter(item => item !== this.$route.name)).then(() => {
          this.$nextTick(() => {
            this.$router.replace({
              path: `/redirect${this.$route.fullPath}`
            })
          })
        })
      }
      setTimeout(() => {
        if (this.$refs.refresh) {
          this.$refs.refresh.classList.remove('active')
          this.$refs.refresh.classList.add('paused')
        }
      }, 1000)
    }
  },
  beforeCreate () {
  },
  created () {
    this.SetCachedViews()
    this.setViews(this.$route)
    this.setBreadcrumb(this.$route)
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100%;

  .el-container {
    width: 100%;
    height: 100%;

    .el-aside {
      transition: width .28s;
      height: 100%;

      .logo {
        height: 52px;

        .logo-name {
          white-space: nowrap;
          color: #303133;
        }

        img {
          width: 24px;
        }
      }
    }
  }

  // 菜单 el-menu
  ::v-deep .el-menu--collapse {
    .el-submenu.is-active {
      .el-submenu__title {
        color: #3377FF;
        transition: width 1s;

        &:before {
          content: ' ';
          width: 4px;
          height: 100%;
          background-color: #3377FF;
          position: absolute;
          left: 0;
        }

        i {
          color: inherit;
        }
      }

      .el-icon-arrow-down {
        color: #3377FF;
      }
    }
  }

  ::v-deep .el-menu {
    min-height: 100%;
    border-right: none;

    .el-menu-item.is-active {
      color: #FFFFFF;
      background: linear-gradient(90deg, #4A87FF 0%, #86AEFF 100%);
    }

    .el-menu--inline > .el-menu-item.is-active {
      background: linear-gradient(90deg, #4A87FF 0%, #A8BCE6 100%);
    }

    // 更换图标和位置调整
    .el-submenu__title {
      .el-submenu__icon-arrow {
        margin-top: -8px;
      }

      .el-icon-arrow-down {
        font-size: 18px;

        &:before {
          content: '\e790';

        }
      }
    }

    // 打开状态
    .is-opened {
      .el-submenu__title {
        color: #3377FF;
        transition: width 1s;
        &:before {
          content: ' ';
          width: 4px;
          height: 100%;
          background-color: #3377FF;
          position: absolute;
          left: 0;
        }

        i {
          color: inherit;
        }
      }

      .el-icon-arrow-down {
        color: #3377FF;
      }
    }

    /*菜单关闭*/
    .el-submenu > .el-submen u__title .el-submenu__icon-arrow {

      transform: rotateZ(-90deg);
    }

    /*菜单展开*/
    .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {

      transform: rotateZ(-90deg);
    }
  }
}

// 刷新按钮start
.refresh {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0);

  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.active {
  animation-play-state: running;
}

.paused {
  animation-play-state: paused;
}

// 刷新按钮end

.tag-views {
  display: flex;
  align-items: center;

  .view-active {
    background-color: #3377FF !important;
    color: #FFFFFF !important;
    opacity: 1 !important;
  }

  .view {
    &:first-child {
      margin-left: 0;
    }

    &:hover {
      opacity: 1;
    }

    opacity: 0.8;
    margin-right: 8px;
    cursor: pointer;
    height: 12px;
    background: #F3F3F3;
    color: #666666;
    border-radius: 4px;
    padding: 10px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-icon-error {
      padding: 10px 0;

      &:hover {
        transform: scale(1.3);
        transition: all .3s;
      }
    }

    img {
      width: 18px;
    }
  }
}

.refresh-btn {
  width: 90px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #E5E5E5;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #666666;
}
</style>
